import React from 'react';

import {
  ButtonDisabledStyle,
  ButtonEnabledStyle,
  ButtonStyle,
  PaddingBySize,
} from './PlainIconButton.styles';

type ButtonSize = 'small' | 'medium' | 'large';

interface PlainIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  size?: ButtonSize;
}

const PlainIconButton: React.FC<PlainIconButtonProps> = ({
  children,
  size = 'medium',
  disabled,
  style,
  ...props
}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      style={{
        ...ButtonStyle,
        ...PaddingBySize[size],
        ...(disabled ? ButtonDisabledStyle : ButtonEnabledStyle),
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
};

export default PlainIconButton;
